import * as React from 'react';
import { Box } from "@mui/system"
import RentalNote from './RentalNote';
import { Accordion, AccordionDetails, AccordionSummary, Button, CircularProgress, IconButton, TextField } from "@mui/material";
import Grid from "@mui/material/Grid2"
import { send_authorized_request } from '../../Constants/cognito'
import UploadFileIcon from "@mui/icons-material/UploadFile";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CloseIcon from '@mui/icons-material/Close';
import { AXIOS_API_INSTANCE } from '../../Constants';
import axios from 'axios';
import Typography from '@mui/material/Typography';
import { useSnackbar } from 'notistack';
import { LoadingBackdropIndeterminate } from '../LoadingBackdrop';

export default function RentalNoteAccordion({ refresh_function, rental_item_id, rental_contract_item_id, disabled }) {
    const { enqueueSnackbar } = useSnackbar()
    const [newRentalNote, setNewRentalNote] = React.useState("")
    const [newRentalNoteImage, setNewRentalNoteImage] = React.useState(undefined)
    const [rentalNotes, setRentalNotes] = React.useState({ rows: [], total_count: 0 })
    const [savingNote, setSavingNote] = React.useState(false)
    const [isLoading, setIsLoading] = React.useState(true)
    const [page, setPage] = React.useState(0)

    const addRentalNote = () => {
        setSavingNote(true)
        const rentalNote = {
            rental_item_id: rental_item_id,
            rental_contract_item_id: rental_contract_item_id,
            text: newRentalNote
        }
        send_authorized_request(() =>
            AXIOS_API_INSTANCE.put(
                `rentalnotes`,
                rentalNote
            ).then((response) => {
                if (newRentalNoteImage !== undefined) {
                    AXIOS_API_INSTANCE.post(`rentalnotes/${response.data.data.id}/image`, { image_name: newRentalNoteImage.name },).then((image_response) => {
                        var bodyFormData = new FormData();
                        for (const key in image_response.data.data.fields) {
                            bodyFormData.append(key, image_response.data.data.fields[key])
                        }
                        bodyFormData.append('file', newRentalNoteImage)
                        axios.post(image_response.data.data.url, bodyFormData, { headers: { 'Content-Type': 'multipart/form-data' } }).then((image_response) => {
                            console.log(image_response)
                            setSavingNote(false)
                            enqueueSnackbar('Successfully created rental note with image', { variant: 'success' })
                            setNewRentalNoteImage(undefined)
                            setNewRentalNote("")
                            setRentalNotes({ rows: [], total_count: 0 })
                            setPage(0)
                        })
                    })
                } else {
                    setSavingNote(false)
                    enqueueSnackbar('Successfully created rental note', { variant: 'success' })
                    setRentalNotes({ rows: [], total_count: 0 })
                    setPage(0)
                }
            })
        )
    }

    const addRentalNoteImage = (event) => {
        if (!event.target.files) {
            return;
        }
        setNewRentalNoteImage(event.target.files[0])
    }

    const getRentalNotes = () => {
        setIsLoading(true)
        let filterVar = {
            "rental_item_id.eq": rental_item_id
        }
        if (rental_contract_item_id !== undefined && rental_contract_item_id !== null) {
            filterVar['rental_contract_item_id.eq'] = rental_contract_item_id
        }
        const pageSize = 5
        send_authorized_request(() =>
            axios
                .all([
                    AXIOS_API_INSTANCE.get("rentalnotes", {
                        params: {
                            page_num: page,
                            page_size: pageSize,
                            order_by: "date_created",
                            order_by_direction: "desc",
                            filters: JSON.stringify(filterVar),
                        },
                    }),
                ])
                .then(
                    axios.spread((newRentalNotes) => {
                        console.log(newRentalNotes)
                        setRentalNotes({
                            rows: rentalNotes.rows.concat(newRentalNotes.data.data),
                            total_count: newRentalNotes.data.total_count,
                        })
                        setIsLoading(false)
                    })
                )
        )
    }
    React.useEffect(() => {
        getRentalNotes()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page])

    return (
        (<Accordion disabled={disabled}>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="rentalnotes-content"
                id="rentalnotes-header"
            >
                <Typography>Rental Item Notes</Typography>
            </AccordionSummary>
            <AccordionDetails>
                <LoadingBackdropIndeterminate
                    open={savingNote}
                    text="Saving Note"
                />
                <Box>
                    <TextField
                        margin="dense"
                        id="rentalnote"
                        label="Rental Note"
                        type="text"
                        fullWidth
                        variant="filled"
                        multiline
                        minRows={2}
                        value={newRentalNote}
                        onChange={(event) => setNewRentalNote(event.target.value)}
                        sx={{ mt: 0 }}
                        slotProps={{
                            input: { maxLength: 2000 }
                        }}
                    />
                    <Grid container spacing={1} justifyContent={'flex-end'}>
                        <Grid size="auto">
                            {newRentalNoteImage &&
                                <Box
                                    sx={{
                                        p: 1,
                                        border: '1px solid grey',
                                        borderRadius: 1,
                                        "&:hover":
                                        {
                                            cursor: 'pointer',
                                            opacity: 0.7,
                                            transition: 'opacity 0.5s ease'
                                        }
                                    }}
                                >
                                    <Grid container alignItems={'center'}>
                                        <Grid size="grow">
                                            <IconButton onClick={() => setNewRentalNoteImage(undefined)}>
                                                <CloseIcon color="inherit" sx={{ display: 'block' }} />
                                            </IconButton>
                                        </Grid>
                                        <Grid size="grow">
                                            <Box
                                                maxHeight={'100px'}
                                                maxWidth={'100px'}
                                                component={'img'}
                                                src={URL.createObjectURL(newRentalNoteImage)}
                                            >
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </Box>
                            }
                        </Grid>
                        <Grid size="grow">
                            <span></span>
                        </Grid>
                        <Grid size="auto">
                            <Button variant="contained" onClick={addRentalNote}>
                                Add Note
                            </Button>
                        </Grid>
                        <Grid size="auto">
                            <Button
                                component="label"
                                variant="contained"
                                startIcon={<UploadFileIcon />}
                                sx={{ marginRight: "1rem" }}
                                disabled={newRentalNoteImage !== undefined}
                            >
                                Add Image
                                <input type="file" accept="image/*" hidden onChange={addRentalNoteImage} />
                            </Button>
                        </Grid>
                    </Grid>
                    <Box sx={{ pb: 1 }}>
                        {
                            (rentalNotes.rows || []).map((item) => {
                                return (
                                    <RentalNote key={item.id} rentalNote={item} />
                                )
                            })
                        }
                    </Box>
                    <Grid container>
                        {isLoading &&
                            <Grid size="auto">
                                <Box>
                                    <CircularProgress />
                                </Box>
                            </Grid>
                        }
                        <Grid size="grow">
                            <Button variant='contained' disabled={isLoading || rentalNotes.rows.length === rentalNotes.total_count} onClick={() => setPage(page + 1)}>Get More Notes ({rentalNotes.rows.length}/{rentalNotes.total_count})</Button>
                        </Grid>
                    </Grid>
                </Box>
            </AccordionDetails>
        </Accordion >)
    );
}